import { skpApiSettings, skpApiSettingsDoc } from '../common/appConstants'
import { firestore, getDoc, doc } from '../../utils/firestore'
import { getCache, addCache } from './cache'

// Settings entry will be used for one hour before a reload.
const settingsExpirationMs = 60 * 60 * 1000

/**
 * @name getFireStoreSkpApiSettings
 * @returns {object} skpApi setting document info
 */
export const getFireStoreSkpApiSettings = async () => {
  let skpAPiDoc = getCache(skpApiSettings, skpApiSettingsDoc)
  if (skpAPiDoc === null) {
    skpAPiDoc = await getDoc(doc(firestore, skpApiSettings, skpApiSettingsDoc))
    addCache(skpApiSettings, skpApiSettingsDoc, skpAPiDoc, settingsExpirationMs)
  }
  return skpAPiDoc
}


/**
 * 
 * @returns {string} complete apiUrl string
 */
export const getAccountLevel1Endpoint = async () => {
  const skpAPiSetting = await getFireStoreSkpApiSettings()
  return skpAPiSetting.data().skpApiWsgBaseUrl + skpAPiSetting.data().endpoints.getAccountLevel1
}

/**
 * 
 * @returns {string} complete apiUrl string
 */
export const getAccountLevel2Endpoint = async () => {
  const skpAPiSetting = await getFireStoreSkpApiSettings()
  return skpAPiSetting.data().skpApiWsgBaseUrl + skpAPiSetting.data().endpoints.getAccountLevel2
}


/**
 * 
 * @returns {string} complete apiUrl string
 */
export const getAccountLevel3Endpoint = async () => {
  const skpAPiSetting = await getFireStoreSkpApiSettings()
  return skpAPiSetting.data().skpApiWsgBaseUrl + skpAPiSetting.data().endpoints.getAccountLevel3
}